import React from 'react';
import './App.css';
import './assets/cards.css';
import './assets/dashboard-theme.css';
import './assets/table-polish.css';
import SuperStore from './DataStore/SuperStore';
import AppInitializer from './pages/AppInitializer';

function App() {
  return (<SuperStore>
            <AppInitializer />
          </SuperStore>
  );
}

export default App;
